import { useEffect, useRef, useState } from 'react';
import { Avatar, Dialog, Toast } from 'antd-mobile';
import { ScanCodeOutline } from 'antd-mobile-icons';
import { getMemberQRCode } from '../services/api';
import './UserHeader.css';

export default function UserHeader({ user }) {
  const [memberQr, setMemberQr] = useState(null);
  const qrRequestRef = useRef(null);

  // 首页进入后立即预取会员二维码，避免首次点击时才开始请求。
  useEffect(() => {
    let cancelled = false;
    qrRequestRef.current = null;
    setMemberQr(null);

    if (!user?.id) {
      return undefined;
    }

    const request = getMemberQRCode(user.id);
    qrRequestRef.current = request;
    request
      .then((response) => {
        if (!cancelled) {
          setMemberQr(response);
        }
      })
      .catch(() => {
        // 点击按钮时会再次请求并向用户展示错误。
        if (qrRequestRef.current === request) {
          qrRequestRef.current = null;
        }
      });

    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  // Generate avatar based on gender or default
  const getAvatarContent = () => {
    if (user?.gender === 'M' || user?.gender === 'male') {
      return '👨';
    } else if (user?.gender === 'F' || user?.gender === 'female') {
      return '👩';
    }
    const nickname = user?.nickName || user?.nickname;
    return nickname ? nickname.slice(0, 1) : 'T';
  };

  const handleShowQRCode = async () => {
    if (!user?.id) {
      Toast.show({ content: 'Please sign in to view QR code' });
      return;
    }

    const loading = Toast.show({
      icon: 'loading',
      content: 'Loading...',
      duration: 0,
    });

    try {
      const response = memberQr || await (qrRequestRef.current || getMemberQRCode(user.id));
      loading.close();

      // 显示二维码对话框
      const dialog = Dialog.show({
        title: 'Member QR Code',
        content: (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <img 
              src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(response.qrCodeLink)}`}
              alt="Member QR Code"
              style={{ width: '200px', height: '200px', margin: '0 auto' }}
            />
            <p style={{ marginTop: '16px', fontSize: '14px', color: '#666' }}>
              Member Code: {response.memberCode}
            </p>
            <p style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>
              Show this QR code for member verification
            </p>
          </div>
        ),
        closeOnMaskClick: true,
        actions: [
          {
            key: 'close',
            text: 'Close',
            onClick: () => {
              dialog.close();
            },
          },
        ],
      });
    } catch (error) {
      loading.close();
      Toast.show({
        icon: 'fail',
        content: error.message || 'Failed to load QR code',
      });
    }
  };

  return (
    <div className="user-header-identity-card">
      <Avatar className="user-header-avatar">
        {getAvatarContent()}
      </Avatar>
      <div className="user-header-identity-info">
        <div className="user-header-member-name">{user?.nickName || user?.nickname || user?.name || 'Tao-go Members'}</div>
        {user?.id && <div className="user-header-member-id">ID: {user.id}</div>}
      </div>
      <div className="user-header-member-badge" onClick={handleShowQRCode}>
        <span>MemberQR</span>
        <ScanCodeOutline style={{ marginLeft: '4px', fontSize: '16px' }} />
      </div>
    </div>
  );
}
